import React, { Component, PropTypes } from 'react';
import LeftBarDetail from './left-bar-detail';
import { Toggle } from 'material-ui';

function getTourDurationUnit({ value, unit }) {
  if (!value || !unit) return undefined;
  let normalizedUnit = unit.split('(')[0];
  if (value > 1) normalizedUnit += 's';
  return `${value} ${normalizedUnit}`;
}

class TourDuration extends Component {

  toggleValue = (field) => {
    const { _saveField, profileToShow } = this.props;
    _saveField({ updateField: field, updateBody: !profileToShow[field] });
  };

  render() {
    const { profileToShow, isEditable, editField } = this.props;
    const showTourDuration = !profileToShow.tourDurationDoesNotApply;
    const tourDurationNodes = [];

    if (isEditable) {
      tourDurationNodes.push(
        <div style={{ marginTop: '32px' }} key="editable">
          <Toggle
            checked={showTourDuration}
            style = {{
              cursor: 'pointer',
              overflow: 'visible',
              width: '100%',
              display: 'inline-block',
              verticalAlign: 'middle',
            }}
            onToggle={this.toggleValue.bind(this, 'tourDurationDoesNotApply')}
            name="toggleName1"
            labelPosition="right"
            label={showTourDuration ? 'Show Tour Duration' : 'Don\'t Show Tour Duration'}
            value="toggleValue1"
          />
        </div>
      );
    }

    if (showTourDuration && ((profileToShow.tourDuration && profileToShow.tourDuration.value) || isEditable)) {
      tourDurationNodes.push(
        <LeftBarDetail
          key="showTourDuration"
          isEditable={isEditable}
          className="segment-content"
          infoToDisplay={getTourDurationUnit(profileToShow.tourDuration)}
          title={"Tour Duration"}
          itemName={"Tour Duration"}
          editField={
            editField.bind(this, 'tourDuration', {
              type: 'tourDuration',
              isRequired: true,
              initialValue: {
                unit: profileToShow.tourDuration.unit,
                value: profileToShow.tourDuration.value,
              },
            })
          }
        />
      );
    }

    return (
      <div id="tourDuration">
        {tourDurationNodes}
      </div>
    );
  }
}

TourDuration.propTypes = {
  profileToShow: PropTypes.object,
  routeName: PropTypes.string,
  isEditable: PropTypes.bool,
  editField: PropTypes.func,
  _saveField: PropTypes.func,
};

export default TourDuration;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-left-bar/tour-duration.jsx